<script lang="ts">
  import { Input } from '$lib/components/ui/input/index.js';

  interface Props {
    name: string | undefined;
    enabled?: boolean;
  }

  let { name = $bindable(), enabled = $bindable(true) }: Props = $props();

  const errorClass = 'border border-rose-600 dark:border-red-800 dark:bg-gray-800';
</script>

<Input
  bind:value={name}
  disabled={!enabled}
  class={enabled && (!name || name === '') ? errorClass : ''}
  placeholder="Name"
/>
